import {IOneAnimeJson} from "../../../../../../nodeserver/structs/database";
import JSX from "../../../helpers/react.js";
import {tjs} from "../../../lang.js";
import AnimeColumn from "../../AnimeColumn.js";
import {ServerApi} from "../../../api.js";
import {handleFetchError} from "../../../helpers/functions.js";
import {FilterAnimeGetParams} from "../../../../../../nodeserver/structs/getparams";
import RefObject = JSX.RefObject;

function AnimeData({animes, filters}: {animes: IOneAnimeJson[], filters: FilterAnimeGetParams}){
    if(!animes) return (
        <div className="center">
            {tjs('nothing_found_shrug')}
        </div>
    );
    const container:RefObject<HTMLDivElement> = {};
    const button: RefObject<HTMLButtonElement> = {};
    let fullyLoaded: boolean = false;
    return (
        <>
            <div className="grid-container" ref={container}>
                {
                    ...animes.map(
                        anime=> AnimeColumn({anime})
                    )
                }
                <gap />
                <gap />
                <gap />
            </div>
            <div className="center" style={{marginTop: "10px"}}>
                <button className="main-button load-more bordered" ref={button} onClick={async ()=> !fullyLoaded && (fullyLoaded=(await loadMore(button.value!, container.value!, filters))!)}>Показать ещё</button>
            </div>
        </>
    );
}
async function loadMore(btn: HTMLButtonElement, container: HTMLDivElement, filters: FilterAnimeGetParams){
    if(btn.classList.contains('blocked')) return;
    btn.classList.add('blocked');
    btn.innerText = '';
    btn.appendChild(<div><i className="loading" /> {tjs('loading')}</div>)
    try {
        const animes = await ServerApi.anime.filter(filters);
        let lastGap: Element|null = container.children[container.childElementCount-1]!;
        while (lastGap?.tagName === 'GAP' && lastGap.previousElementSibling?.tagName === 'GAP')
            lastGap = lastGap.previousElementSibling!
        for(const a of animes.reverse())
            container.insertBefore( <AnimeColumn anime={a}/>, lastGap);
        (filters.offset as number) += 24;
        const fullyLoaded = animes.length < 24;
        if(fullyLoaded) btn.style.display='none';
        return fullyLoaded;
    }
    catch (e){
        handleFetchError(e);
        return false;
    }
    finally {
        btn.classList.remove('blocked');
        btn.innerText = tjs('show_more');
    }
}
function NothingFound(){
    return (
        <div className="center">
            {tjs('nothing_found')}<br />
            {tjs('search_try_filter')}
        </div>
    )
}
export function FilterPage({animes, filters}: {animes: IOneAnimeJson[], filters: FilterAnimeGetParams}){
    return (
        <div>
            {
                animes.length ?
                    <AnimeData animes={animes} filters={filters}/> :
                    <NothingFound />
            }
        </div>
    );

}